import { format } from 'date-fns';
import {
  ArrowLeft,
  ChevronDown,
  Download,
  Hospital,
  UserRoundPlus,
} from 'lucide-react';
import { Button } from '@predoc/cow';
import { PageHeader } from '@/components/PageHeader';
import { getProfileColor } from '@/utils/helpers';

interface FacesheetViewerHeaderProps {
  title: string;
  generatedAt?: Date;
  patientFullName?: string;
  profileName?: string;
  profileAvatarType?: string;
  backAriaLabel?: string;
  onBack?: () => void;
}

export const FacesheetViewerHeader = ({
  title,
  generatedAt,
  patientFullName,
  profileName,
  profileAvatarType,
  backAriaLabel = 'Close document viewer',
  onBack,
}: FacesheetViewerHeaderProps) => {
  return (
    <PageHeader>
      <div className="flex items-center gap-3">
        {onBack ? (
          <Button
            variant="ghost"
            size="icon"
            onClick={onBack}
            aria-label={backAriaLabel}
            className="size-9"
          >
            <ArrowLeft className="size-5" />
          </Button>
        ) : null}
        <h1 className="text-lg font-semibold text-gray-900">{title}</h1>
      </div>

      <div className="flex items-center gap-6">
        {generatedAt ? (
          <span className="text-sm text-gray-600">
            Generated {format(generatedAt, 'MM/dd/yyyy')}
          </span>
        ) : null}
        {patientFullName ? (
          <span className="flex items-center gap-1.5 text-sm text-gray-900">
            <UserRoundPlus className="size-4" />
            {patientFullName}
          </span>
        ) : null}
        {profileName ? (
          <span className="flex items-center gap-1.5 text-sm text-gray-900">
            <Hospital
              className="size-4"
              style={{ color: getProfileColor(profileAvatarType || '') }}
            />
            {profileName}
          </span>
        ) : null}
        <Button
          type="button"
          variant="outline"
          className="flex items-center gap-2"
          disabled
          aria-label="Download"
        >
          <Download className="size-4" />
          Download
          <ChevronDown className="size-4" />
        </Button>
      </div>
    </PageHeader>
  );
};
